import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSettings } from "@/hooks/useSettings";

export const printList = () => {
  document.body.classList.add("print-list");
  const done = () => { document.body.classList.remove("print-list"); window.removeEventListener("afterprint", done); };
  window.addEventListener("afterprint", done);
  setTimeout(() => window.print(), 100);
};

export const PrintListButton = ({ label = "Imprimer la liste", className = "" }) => (
  <Button variant="outline" className={`print:hidden ${className}`} onClick={printList} data-testid="print-list-btn"><Printer size={16} /> {label}</Button>
);

// Encadre une liste imprimable : titre + date visibles uniquement à l'impression.
export const PrintArea = ({ title, subtitle, children }) => {
  const { settings } = useSettings();
  return (
    <div id="list-print">
      <div className="hidden print:block mb-3">
        <p className="font-display text-xl font-bold">{settings?.company_name} — {title}</p>
        <p className="text-xs">{subtitle ? `${subtitle} · ` : ""}Imprimé le {new Date().toLocaleString("fr-FR")}</p>
      </div>
      {children}
    </div>
  );
};
